export const ROUTES = {
  home: '',
  login: 'auth/login',

  leasingScoring: 'leasing-scoring',
  leasingScoringCreate: 'leasing-scoring/create',
  leasingScoringRequest: (id = ':id') => `leasing-scoring/${id}`,

  leasedProperty: 'leased-property',
  leasedPropertyCreate: 'leased-property/create',
  leasedPropertyInfo: (id = ':id') => `leased-property/${id}`,

  contracts: 'contracts',
  contractsCreate: 'contracts/create',
  contract: (id = ':id') => `contracts/${id}`,

  clients: 'clients',
  client: (id = ':id') => `clients/${id}`,

  clientAppeals: 'client-contract-appeals',
  clientAppeal: (id = ':id') => `client-contract-appeals/${id}`,

  assessments: 'assessments',
  vehicleAssessment: (appealUuid = ':appealUuid') =>
    `assessments/${appealUuid}`,

  reports: 'reports',

  statistics: 'statistics'
};

export const ADMIN_ROUTES = {
  root: 'admin',

  partners: 'partners',
  partnersCreate: 'partners/create',
  partner: (id = ':id') => `partners/${id}`,
  dealersCreate: 'dealers/create',
  dealer: (id = ':id') => `dealers/${id}`,
  assessmentCentersCreate: 'assessment-centers/create',
  assessmentCenter: (id = ':id') => `assessment-centers/${id}`,

  branches: 'branches',
  branchesCreate: 'branches/create',
  branch: (id = ':id') => `branches/${id}`,

  products: 'products',
  productsCreate: 'products/create',
  product: (id = ':id') => `products/${id}`,

  auto: 'auto',
  brandsCreate: 'auto/brands/create',
  brand: (id = ':id') => `auto/brands/${id}`,
  modelsCreate: 'auto/models/create',
  model: (id = ':id') => `auto/models/${id}`,
  equipmentsCreate: 'auto/equipments/create',
  equipment: (id = ':id') => `auto/equipments/${id}`,

  users: 'users',
  usersCreate: 'users/create',
  user: (id = ':id') => `users/${id}/update`,
  positionCreate: 'users/position/create',
  position: (id = ':id') => `users/position/${id}/update`,
  rolesActionCreate: 'users/roles-action/create',
  rolesAction: (id = ':id') => `users/roles-action/${id}/update`,

  clients: 'clients',
  client: (id = ':id') => `clients/${id}`,

  blackList: 'black-list',
  blackListCreate: 'black-list/create',
  blackListItem: (id = ':id') => `black-list/${id}`,

  modules: 'modules',
  modulesCreate: 'modules/create',
  module: (id = ':id') => `modules/${id}`,

  reports: 'reports',

  externalServices: 'external-services',
  externalServicesCreate: 'external-services/create',
  externalService: (id = ':id') => `external-services/${id}`,

  leasings: 'leasings',
  leasingsCreate: 'leasings/create',
  leasing: (id = ':id') => `leasings/${id}`,

  systemSettings: 'system-settings'
};

export const getFullAdminRoute = (route: string) => {
  return `${ADMIN_ROUTES.root}/${route}`;
};
